import React from 'react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-98" data-mp="1o3ncvzyfwkwu">
      <Reveal className="mx-auto max-w-2xl rounded-2xl border border-amber/50 bg-mist p-9 text-center shadow-premium sm:p-12" data-id="element-99" data-mp="1o3dmwcdeadr5">
        <div className="text-5xl" data-id="element-100" data-mp="1x4bsv07e8vcd">🛡️</div>
        <h2 className="mt-5 font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-101" data-mp="1x5d69bbvttx9">
          Zéro risque. Garantie de remboursement 7 jours.
        </h2>
        <p className="mt-6 text-sm leading-7 text-slate sm:text-base" data-id="element-102" data-mp="14fo2wrbp9hsh">
          Téléchargez les 6 tomes et les 5 bonus aujourd’hui. Imprimez les cartes de constellation. Travaillez les
          modèles de génogramme. Appliquez les phrases de guérison. Si dans les 7 jours vous ne ressentez pas un
          changement profond — nous vous rembourserons chaque centime. Sans formulaires. Sans questions. Sans tracas. Le
          risque est entièrement le nôtre.
        </p>
        <p className="mt-7 font-semibold text-sage" data-id="element-103" data-mp="lowmx6x7it54">✅ Taux de remboursement réel : moins de 1%</p>
      </Reveal>
    </section>;
}